import React, { ReactNode } from "react";
interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  eyebrow?: ReactNode;
}
export function PageHeader({
  title,
  description,
  actions,
  eyebrow
}: PageHeaderProps) {
  return <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-81" data-mp="22ufwkyhdbd62">
      <div className="min-w-0" data-id="element-82" data-mp="1yungm0pna4qo">
        {eyebrow && <div className="mb-2" data-id="element-83" data-mp="1b3runk7ve3rc">{eyebrow}</div>}
        <h1 className="text-[28px] font-bold leading-tight tracking-[-0.02em] text-ink md:text-4xl" data-id="element-84" data-mp="1b4ta00vx5cev">{title}</h1>
        {description && <p className="mt-2 max-w-[60ch] text-[15px] leading-relaxed text-ink-2 md:text-base" data-id="element-85" data-mp="166j9rbvc7lme">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-3" data-id="element-86" data-mp="1f5mvknlw2f4l">{actions}</div>}
    </div>;
}